module.exports = {"TXTCLI_No_data_available":{"id":"TXTCLI_No_data_available","defaultMessage":"Nejsou k dispozici žádná data"}}